// alterado

import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainerReportResumo,
    GridItem2,
    GridItem4,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivBodyResumo,
    CardGridDivBodyResumoTotal,
} from '../../../business-components/Card/Card'

import {
    formataReportTituloLinha,
    formataReportTituloLinhaTotal,
    formataReportTexto,
    formataReportTextoTotal,
    formataReportValor,
    formataReportValorTotal,
} from '../../../business-components/Formata/Formata'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    formataTempoCobertura,
} from '../estudo-form/EstudoService'



const EstudoReportResumoNecessidadeProtecaoPanel = ({ values, panelValores, tipoPanel }) => {

    const GridItem2smDown2Right = (props) => { // mudança fonte: GridItem2smDown2Center
    
        return (
            <GridItem2
                align='right' // mudança fonte: 'center'
                {...props}
            />
        )
    }

    const GridItem2smDown2RightMt1 = (props) => { // mudança fonte: GridItem2smDown2CenterMt1
    
        return (
            <GridItem2
                className="mt-1"
                align='right' // mudança fonte: 'center'
                {...props}
            />
        )
    }

    return (
        <>
            <GridItem12
                className='mt-4 mb-3'
            >
                {panelValores?.map((item, ind) => (
                    panelValores.length <= ind + 1
                        ?
                            <div
                                key={ind}
                            >
                                <CardGridDivBodyResumoTotal>
                                    <GridContainerReportResumo>
                                        <GridItem4>
                                            {
                                                formataReportTituloLinhaTotal(
                                                    tipoPanel === HARDCODE.tipoPanelGarantiasAtuais
                                                        ?
                                                            LABEL.garantiasAtuais.toUpperCase() // mudança da fonte: uppercase
                                                        :
                                                            item.descricao.toUpperCase() // mudança da fonte: uppercase
                                                )
                                            }
                                        </GridItem4>
                                        <GridItem2smDown2RightMt1/>
                                        {dadosCompletosCliente(values) && (
                                            <GridItem2smDown2RightMt1>
                                                {
                                                    formataReportValorTotal(
                                                        tipoPanel === HARDCODE.tipoPanelGarantiasAtuais
                                                            ?
                                                                item.valorReceitaClientePainel
                                                            :
                                                                item.valorDespesaClientePainel
                                                    )
                                                }
                                            </GridItem2smDown2RightMt1>
                                        )}
                                        {dadosCompletosConjuge(values) && (
                                            <GridItem2smDown2RightMt1>
                                                {
                                                    formataReportValorTotal(
                                                        tipoPanel === HARDCODE.tipoPanelGarantiasAtuais
                                                            ?
                                                                item.valorReceitaConjugePainel
                                                            :
                                                                item.valorDespesaConjugePainel
                                                    )
                                                }
                                            </GridItem2smDown2RightMt1>
                                        )}
                                        <GridItem2smDown2RightMt1>
                                            {
                                                tipoPanel === HARDCODE.tipoPanelDespesasTotais
                                                    ?
                                                        formataReportTextoTotal(formataTempoCobertura(item.anosProtegerProtegido))
                                                    :
                                                        ''
                                            }
                                        </GridItem2smDown2RightMt1>
                                    </GridContainerReportResumo>
                                </CardGridDivBodyResumoTotal>
                            </div>
                        :
                            ''
                ))}
            </GridItem12>

            <GridItem12>
                {panelValores?.map((item, ind) => (
                    panelValores.length > ind + 1
                        ?
                            <div
                                key={ind}
                            >
                                <CardGridDivBodyResumo
                                    className={ind % 2 === 0 ? 'bg-cardGridDivBodyResumo' : ''}
                                >
                                    <GridContainerReportResumo>
                                        <GridItem4>
                                            {
                                                formataReportTituloLinha(item.descricao)
                                            }
                                        </GridItem4>
                                        <GridItem2smDown2Right/>
                                        {dadosCompletosCliente(values) && (
                                            <GridItem2smDown2Right>
                                                {
                                                    formataReportValor(
                                                        tipoPanel === HARDCODE.tipoPanelGarantiasAtuais
                                                            ?
                                                                item.valorReceitaClientePainel
                                                            :
                                                                item.valorDespesaClientePainel
                                                    )
                                                }
                                            </GridItem2smDown2Right>
                                        )}
                                        {dadosCompletosConjuge(values) && (
                                            <GridItem2smDown2Right>
                                                {
                                                    formataReportValor(
                                                        tipoPanel === HARDCODE.tipoPanelGarantiasAtuais
                                                            ?
                                                                item.valorReceitaConjugePainel
                                                            :
                                                                item.valorDespesaConjugePainel
                                                    )
                                                }
                                            </GridItem2smDown2Right>
                                        )}
                                        <GridItem2smDown2Right>
                                            {
                                                tipoPanel === HARDCODE.tipoPanelDespesasTotais
                                                    ?
                                                        formataReportTexto(formataTempoCobertura(item.anosProtegerProtegido, true))
                                                    :
                                                        ''
                                            }
                                        </GridItem2smDown2Right>
                                    </GridContainerReportResumo>
                                </CardGridDivBodyResumo>
                            </div>
                        :
                            ''
                ))}
            </GridItem12>
        </>
    )
}

export default EstudoReportResumoNecessidadeProtecaoPanel